import React from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row"
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SeriesValueChart from "../../charts/SeriesValueChart/SeriesValueChart";

const SeriesWidget = ({  title, startYear, chartClassName, subtitle, additionalYears,
    options, locale, legendLabels, showTitle, showSubtitle, data = {}, error = ""}) => {

  return (
        <Card.Body>
          <Row className="h-25 d-block d-xl-flex align-items-center">
            <Col xs={12} className="px-xl-0">
            {showTitle &&
              <h5 className="fw-normal mb-2">
                {error ? "Service unavailable" : title}
              </h5>
            }
            </Col>
            {showSubtitle && <Col xs={12} className="d-flex align-items-center justify-content-xl-center px-xl-0">
              <h6 className="mt-3 mb-1  text-dark-lc">{subtitle}</h6>
              {/* <h3>{total ? total.toLocaleString('en-GB') : "loading..."}</h3> */}
            </Col>}
            <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0">
              <SeriesValueChart
                labels={data.labels}
                series={data.series}
                chartClassName={chartClassName}
                options={options}
                locale={locale}
              /> 
            </Col>
            <Col xs={12} className="text-xl-center d-flex align-items-center justify-content-xl-center mt-3 mb-3 mb-xl-0">
            {
              (additionalYears && legendLabels) && 
              <ul className="series-value-legend">
                <li key={`icon_year_${startYear}`}><FontAwesomeIcon className="me-2 text-dark-lc" icon={faCircle} />{legendLabels[startYear]}</li>
                {
                  additionalYears.map((y, i ) => {
                    return <li key={`icon_year_${y}`}><FontAwesomeIcon icon={faCircle} className={`me-2  text-secondary-lc legend-icon-${i+1}`}/>
                              {legendLabels[y]}
                            </li>
                  })
                }
              </ul>
            }
            </Col>
          </Row>
        </Card.Body>
      )
    };
export default SeriesWidget;